/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { McpServer, McpServer$inboundSchema } from "./mcpserver.js";

/**
 * Result type for listing MCP servers
 */
export type ListMcpServersResult = {
  mcpServers: Array<McpServer>;
};

/** @internal */
export const ListMcpServersResult$inboundSchema: z.ZodMiniType<
  ListMcpServersResult,
  unknown
> = z.pipe(
  z.object({
    mcp_servers: z.array(McpServer$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "mcp_servers": "mcpServers",
    });
  }),
);

export function listMcpServersResultFromJSON(
  jsonString: string,
): SafeParseResult<ListMcpServersResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListMcpServersResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListMcpServersResult' from JSON`,
  );
}
